  
import React from "react";

const Webfeatures = () => {
  return (
    <>
      <style>{`
        /* Mobile screens */
        @media (max-width: 768px) {
          .web-container {
            flex-direction: column !important;
            text-align: center;
          }
          .web-left {
            padding-right: 0 !important;
            margin-top: 1rem;
          }
          .web-header {
            font-size: 1.5rem !important;
          }
          .web-paragraph {
            font-size: 0.95rem !important;
          }
          .web-listItem {
            font-size: 0.9rem !important;
          }
          .web-image {
            width: 100% !important;
            max-width: 350px !important;
          }
        }
      `}</style>

      <div style={styles.container} className="web-container">
        <div style={styles.rightSide}>
          <div style={styles.imageContainer}>
            <img
              src="/image/devfeatures.webp"
              alt="AI Representation"
              style={styles.image}
              className="web-image"
            />
          </div>
        </div>

        <div style={styles.leftSide} className="web-left">
          <h2 style={styles.header} className="web-header">What We Offer</h2>
          <p style={styles.paragraph} className="web-paragraph">
            End-to-end web development solutions for businesses of all sizes.
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem} className="web-listItem">
              <span style={styles.arrow}>➔</span> <b>Custom Website Development</b> – Tailored solutions for your unique needs.
            </li>
            <li style={styles.listItem} className="web-listItem">
              <span style={styles.arrow}>➔</span> <b>Responsive Design</b> – Optimized for all devices and screen sizes.
            </li>
            <li style={styles.listItem} className="web-listItem">
              <span style={styles.arrow}>➔</span> <b>eCommerce Development</b> – Build powerful online stores with seamless user experiences.
            </li>
            <li style={styles.listItem} className="web-listItem">
              <span style={styles.arrow}>➔</span> <b>Backend Development</b> – Robust and secure server-side development.
            </li>
            <li style={styles.listItem} className="web-listItem">
              <span style={styles.arrow}>➔</span> <b>SEO Optimization</b> – Ensure your website ranks higher on search engines.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "2rem",
    backgroundColor: "#025261",
    color: "#fff",
    flexWrap: "wrap",
    width: "100%",
  },
  leftSide: {
    flex: 1,
    paddingRight: "2rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  header: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "white",
  },
  paragraph: {
    fontSize: "1rem",
    margin: "1rem 0",
    textAlign: "justify",
  },
  list: {
    listStyleType: "none",
    paddingLeft: 0,
  },
  listItem: {
    fontSize: "1rem",
    marginBottom: "0.5rem",
    display: "flex",
    alignItems: "flex-start",
  },
  arrow: {
    marginRight: "0.5rem",
    color: "#4CAF50",
    fontSize: "1.5rem",
    flexShrink: 0,
  },
  rightSide: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "1rem",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: "90%",
    maxWidth: "500px",
    height: "auto",
    borderRadius: "8px",
  },
};

export default Webfeatures;
